"use strict";

var IBMap = new Class({
	Implements: [Options, Events],

	options: {
		polygon: {
			idle: {
				strokeColor: "#bc3a5b",
				strokeWeight: 2,
				strokeOpacity: 0.4,
				fillColor: "#000000",
				fillOpacity: 0,
				clickable: true
			},
			hover: {
				fillColor: "#bc3a5b",
				fillOpacity: 0.35,
				clickable: true
			},
			active: {
				strokeColor: "#008C99",
				strokeWeight: 4,
				strokeOpacity: 0.8,
				fillColor: "#000000",
				fillOpacity: 0,
				clickable: false
			}
		},

		data: null,
		country_marker_img: Res_i + '/w/ibmap/country-marker.png',
		country_marker_hover_img: Res_i + '/w/ibmap/country-marker-hover.png'
	},

	initialize: function initialize(element, options) {
		if (!element) return;

		this._element = element;

		this.setOptions(options);
		this.build();
	},

	build: function build() {
		var self = this;

		this._element.addClass('_loading');
		this._map = this._element.getElement('.map');
		this._back = this._element.getElement('.back');

		this._country_info = this._element.getElement('.country_info');

		this._country_info.addEvents({
			'mouseleave': function mouseleave(e) {
				if (self.current_country_marker) {
					self.replace_marker_image(self.current_country_marker, self.options.country_marker_img);
				}

				self.hide_country_info();
			}
		});

		// CRFOUR-115, need some delay for Safari
		(function () {
			this.map_width = this._map.getSize().x;
			this.map_height = this._map.getSize().y;
		}).delay(1000, this);

		this._map_img = this._map.getElement('img').fade('hide').setStyles({
			'width': 'auto'
		});

		this._map.addEvents({
			'click:relay(.continent_marker)': function clickRelayContinent_marker(e, _el) {
				if (e && e.stop) e.stop();
				self.show_countries(_el);
			},

			'mousedown': function mousedown(e) {
				if (e && e.stop) e.stop();

				self.current_shift_left = e.page.x;
				self.current_shift_top = e.page.y;

				self.mouse_is_down = true;

				return false;
			}
		});

		$(document.body).addEvents({
			'mousemove': function mousemove(e) {
				if (self.mouse_is_down && self._element.hasClass('_detailed')) {
					var left = self._map.getStyle('left').toInt() + e.page.x - self.current_shift_left;
					var top = self._map.getStyle('top').toInt() + e.page.y - self.current_shift_top;

					if (left < self._map.max_left) {
						left = self._map.max_left;
					}

					if (left > self._map.max_right) {
						left = self._map.max_right;
					}

					if (top < self._map.max_up) {
						top = self._map.max_up;
					}

					if (top > self._map.max_down) {
						top = self._map.max_down;
					}

					self._map.setStyles({
						'left': left,
						'top': top
					});

					self.current_shift_left = e.page.x;
					self.current_shift_top = e.page.y;
				}
			},

			'mouseleave': function mouseleave() {
				self.mouse_is_down = false;
			},

			'mouseup': function mouseup() {
				self.mouse_is_down = false;
			}
		});

		var map_src = this._map_img.get('src');

		new Asset.image(map_src, {
			onLoad: function onLoad() {
				self.full_map_width = self._map_img.width;
				self.full_map_height = self._map_img.height;

				self._map.max_up = self.map_height - self.full_map_height;
				self._map.max_left = self.map_width - self.full_map_width;
				self._map.max_down = 0;
				self._map.max_right = 0;

				self._map_img.setStyles({
					'width': ''
				});

				self._map_img.fade('in');
			}
		});

		this._back.addEvent('click', function (e) {
			if (e && e.stop) e.stop();

			self.hide_countries();
		});

		var rpc = this._element.getAttribute('data-rpc');

		new Remote({
			rpc: rpc,
			onSuccess: function onSuccess() {
				self.data = this.get_data();
				self.inject_continents();
				self.inject_countries();
			}
		});
	},

	inject_continents: function inject_continents() {
		if (!this.data || !this.data.continents) return;

		var self = this,
		    continent_marker_img = Res_i + '/w/ibmap/continent-marker.png',
		    continent_marker_hover_img = Res_i + '/w/ibmap/continent-marker-hover.png';

		this._continent_markers = [];

		Object.each(this.data.continents, function (e) {
			var _el = new Element('div', {
				'class': 'continent_marker',
				'html': '<img src="' + continent_marker_img + '"/><span class="label">' + Core.add_commas(e.total) + '</span>'
			}).fade('hide');

			_el.setStyles({
				'left': e.lng,
				'top': e.lat
			});

			_el.total = e.total;

			self._continent_markers.push(_el);

			self._map.adopt(_el);
		});

		new Asset.image(continent_marker_hover_img, {
			onLoad: function onLoad() {
				self._continent_markers.each(function (_el) {
					_el.addEvents({
						'mouseenter': function mouseenter() {
							self.replace_marker_image(_el, continent_marker_hover_img);
						},

						'mouseleave': function mouseleave() {
							self.replace_marker_image(_el, continent_marker_img);
						}
					});
				});
			}
		});

		new Asset.image(continent_marker_img, {
			onLoad: function onLoad() {
				self.resize_markers();
			}
		});

		this._element.removeClass('_loading');
	},

	inject_countries: function inject_countries() {
		if (!this.data || !this.data.countries) return;

		var marker_width;
		var self = this,
		    countries = this.data.countries,
		    country_marker_img = this.options.country_marker_img,
		    country_marker_hover_img = this.options.country_marker_hover_img,
		    marker_height = marker_width = 0;

		this._country_markers = [];

		var _img = new Element('img', { src: country_marker_img });

		var __place_countries = function __place_countries() {
			Object.each(countries, function (e) {
				if (!e.total || e.total.toInt() == 0) return;

				var _el = new Element('div', {
					'class': 'country_marker'
				}).adopt(_img.clone());

				_el.setStyles({
					'left': e.lng - marker_width / 2,
					'top': e.lat - marker_height / 2
				});

				_el.total = e.total;
				_el.country_name = e.name;
				_el.flag = Res_i + '/p/inb/flags/' + e.img + '.png';

				self._country_markers.push(_el);

				self._map.adopt(_el);
			});
		};

		new Asset.image(country_marker_img, {
			onLoad: function onLoad() {
				marker_height = _img.height;
				marker_width = _img.width;

				__place_countries();
			}
		});

		new Asset.image(country_marker_hover_img, {
			onLoad: function onLoad() {
				self._country_markers.each(function (_el) {
					_el.addEvents({
						'mouseenter': function mouseenter() {
							self.current_country_marker = _el;

							self.replace_marker_image(_el, country_marker_hover_img);
							self.show_country_info(_el);
						},

						'mouseleave': function mouseleave(e) {
							if (self.cursor_is_in_infodiv(e)) return;

							self.replace_marker_image(_el, country_marker_img);
							self.hide_country_info();
						}
					});
				});
			}
		});
	},

	cursor_is_in_infodiv: function cursor_is_in_infodiv(e) {
		var x = e.page.x;
		var y = e.page.y;
		var coords = this._country_info.getElement('img').getCoordinates();
		var box_top = coords.top;
		var box_bottom = coords.bottom;
		var box_left = coords.left;
		var box_right = coords.right;

		return x < box_right && x > box_left && y > box_top && y < box_bottom;
	},

	resize_markers: function resize_markers() {
		var max = 0;
		var min = 0;

		var img_width = this._continent_markers[0].getElement('img').width;
		var circle_length = 2 * Math.PI * (img_width / 2);

		this._continent_markers.each(function (_el) {
			if (_el.total > max) {
				max = _el.total.toInt();
			}

			if (min == 0 || min > _el.total) {
				min = _el.total.toInt();
			}
		});

		// var log_min = this.log2(min);
		// var log_max = this.log2(max);

		// log_min = (this.is_integer(log_min))? log_min - 0.1 : log_min;
		// log_max = (this.is_integer(log_max))? log_max + 0.1 : log_max;

		// var log_width = Math.ceil(log_max*10) - Math.floor(log_min*10) + 10;
		// var coef = img_width / log_width;

		this._continent_markers.each(function (_el) {
			var cl = _el.total * 100 / max * circle_length / 100;
			var iw = cl / (Math.PI * 2) * 2;

			// var iw = coef * (self.log2(_el.total) - Math.floor(log_min)) * 10;

			if (iw < 50) iw = 50;

			_el.getElement('img').setStyle('width', iw);

			var _label = _el.getElement('.label');
			var lh = _label.getSize().y;

			_label.setStyle('top', (iw - lh) / 2);

			_el.top = _el.getStyle('top').toInt();
			_el.left = _el.getStyle('left').toInt();

			_el.setStyles({
				'top': _el.top - iw / 2,
				'left': _el.left - iw / 2
			});

			_el.fade('in');
		});
	},

	replace_marker_image: function replace_marker_image(_el, src) {
		var _img = _el.getElement('img');

		if (!_img) return;

		_img.set('src', src);
	},

	show_countries: function show_countries(_el) {
		var top_percent = _el.top * 100 / this.map_height;
		var left_percent = _el.left * 100 / this.map_width;

		var top_center = this.full_map_height * top_percent / 100;
		var left_center = this.full_map_width * left_percent / 100;

		var top = (top_center - this.map_height / 2) * -1;
		var left = (left_center - this.map_width / 2) * -1;

		this._element.addClass('_detailed');

		this._map.setStyles({
			'top': top,
			'left': left
		});
	},

	hide_countries: function hide_countries() {
		var self = this;

		self._element.removeClass('_detailed');

		this._map.setStyles({
			'top': 0,
			'left': 0
		});
	},

	show_country_info: function show_country_info(_el) {
		var _flag = this._country_info.getElement('img').set('src', '');
		var _number = this._country_info.getElement('.number');
		var _country_name = this._country_info.getElement('.country_name span');

		_flag.set('src', _el.flag);
		_number.set('text', Core.add_commas(_el.total));
		_country_name.set('text', _el.country_name);

		this._country_info.show();
	},

	hide_country_info: function hide_country_info() {
		this._country_info.hide();
	},

	log2: function log2(val) {
		return Math.log(val) / Math.log(2);
	},

	is_integer: function is_integer(num) {
		return num.round() == num || num.round(1) - num.round() == 0;
	}
});
'use strict';

/*
--- 
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires: 
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var EqualHeight = new Class({

	initialize: function initialize(element) {
		this._element = element;

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var _children = this._element.getElements('.equal_height_element');

		if (_children.length == 0) {
			_children = this._element.getChildren();
		}

		if (_children.length > 1) {
			var h = this.height = 0;

			_children.each(function (_el) {

				h = _el.getSize().y - _el.getStyle('padding-top').toInt() - _el.getStyle('padding-bottom').toInt();

				this.height = h > this.height ? h : this.height;
			}.bind(this));

			_children.each(function (_el) {
				_el.setStyle('height', this.height);
			}.bind(this));
		}
	}

});
'use strict';

/*
---
description: FED Process
authors:
- David Chan CK
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.1: '*'
...
*/

var TalkToUs = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_talk_to_us'
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);
		this._element = _element || document.getElement('.' + this.options.cls);

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var self = this;
		this._email = this._element.getElement('.email');
		var _form_close = this._element.getElement('.close_btn');

		this._email.getElement('a.hover').addEvent('click', function (e) {
			if (e && e.stop) e.stop();
		});

		this._email.addEvents({
			click: function click() {
				self._email.clicked = true;
			},
			mouseenter: function mouseenter() {
				self._email.addClass('_open');
			},
			mouseleave: function mouseleave() {
				if (self._email.clicked) return;

				self._email.removeClass('_open');
			}
		});

		if (_form_close) {
			_form_close.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				self._email.removeClass('_open');
				self._email.clicked = false;
			});
		}

		this._form_wrapper = this._email.getElement('.email_box');
		if (this._form_wrapper) {
			new Blimp.Form(null, {
				build: function build(blimp_form) {
					if (Blimp.Form.instances && Blimp.Form.instances.contains(blimp_form)) {
						return;
					}
					blimp_form._element = self._form_wrapper;
					blimp_form.post_process();

					Blimp.Form.instances.include(blimp_form);
				},
				onFormSuccess: function onFormSuccess() {
					self.handle_form_success();
				},
				post_process_build: false,
				replace_by_result: false,
				keep_form_on_success: true,
				show_veil: false,
				auto_hide_form: false
			});
		}
	},
	handle_form_success: function handle_form_success() {
		var self = this;
		this._form = this._email.getElement('form');
		this._form.hide();

		var _msg = this._element.getElement('.message_sent');

		if (_msg) _msg.show();

		(function () {
			self._email.removeClass('_open');
			self._form.show();
			if (_msg) _msg.hide();
		}).delay(5000);
	}
});
'use strict';

/*
--- 
description: FED Process
authors: 
- David Chan CK
license:
- MIT-style license
requires: 
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
Page.Mgi = new Class({
	Extends: Page,
	build: function build() {
		this.parent();

		Core.add_equal_height_support();
		Core.stick_last_ads();

		new IBMap(document.getElement('.w_ib_map'));
	}
});
//# sourceMappingURL=mgi.js.map
